import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 10px;
`

export const CommentBox = styled.div`
  border-radius: 20px;
  align-self: flex-start;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.foreground};
`

export const UserName = styled.span`
  color: ${({ theme }) => theme.colors.text};
  font-weight: bold;
  font-size: 16px;
`

export const Info = styled.span`
  color: ${({ theme }) => theme.colors.text};
  font-size: 16px;
`

export const DateLabel = styled.span`
  color: ${({ theme }) => theme.colors.text};
  font-size: 12px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CommentContainer = styled.div`
  flex: 1;
`
